import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { api } from '../../lib/api';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const [state, setState] = useState('loading'); // loading | ok | denied

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      setState('denied');
      return;
    }
    api
      .get('/admin/me')
      .then(() => setState('ok'))
      .catch(() => {
        localStorage.removeItem('adminToken');
        setState('denied');
      });
  }, []);

  if (state === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center text-ink-3">
        <Loader2 className="w-5 h-5 animate-spin" />
      </div>
    );
  }
  if (state === 'denied') return <Navigate to="/admin/login" replace />;
  return children;
};

export default ProtectedRoute;
